import React, { useMemo } from 'react';
import { usePlacingPayment } from 'contexts/placingPayment';
import { currencyFormat } from 'utils/number';
import { useTranslation } from 'react-i18next';

interface UseViewModelProps {
  amount?: number;
  center: boolean;
}

const useViewModel = ({ amount, center }: UseViewModelProps) => {
  const { t } = useTranslation();
  const { totalTipSummary, totalTipPercent, select } = usePlacingPayment();
  const selectCustomTip = 3;
  const totalTip = useMemo(() => {
    return currencyFormat(totalTipSummary(amount));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalTipPercent, amount]);

  const tipDescription = useMemo(() => {
    return totalTipPercent > 0
      ? center
        ? `${t('IncludingOf')} ${totalTip} ${t('tip')}`
        : `${t('tip')} ${totalTipPercent}%`
      : t('tip');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalTipPercent]);

  const isShowTip = useMemo(() => {
    return totalTipPercent !== 0 || select === selectCustomTip;
  }, [totalTipPercent, select]);

  return {
    tipDescription,
    totalTip,
    totalTipPercent,
    select,
    isShowTip,
  };
};

export default useViewModel;
